<div class="pa-file-list" *ngIf="files.length > 0">
  <p-menu 
    appendTo="body" 
    #menu 
    [model]="menuItems" 
    styleClass="pa-file-list-menu" 
    [popup]="true">
    <ng-template #item let-item>
      <a class="p-menuitem-link">
        <div class="file-item">
          <div class="file-icon-wrapper">
            <ng-container *ngIf="isImage(item.data.ext); else fileIcon">
              <div class="file-image">
                <img [src]="item.data.url_preview" [alt]="item.label">  
              </div>
            </ng-container>
            <ng-template #fileIcon>
              <div class="file-icon">
                <i [class]="item.icon"></i>
              </div>
            </ng-template>
          </div>
          <div class="file-name">
            <span class="p-menuitem-text">{{ item.label }}</span>
          </div>
        </div>
      </a>
    </ng-template>
  </p-menu>
  <pa-button 
    (click)="handleButtonClick($event)" 
    [icon]="buttonIcon" 
    [label]="buttonLabel" 
    [severity]="buttonSeverity"
    [variant]="'outlined'"
    iconPos="right">
  </pa-button>
</div> 